<template>
  <main>
    <b-modal
      id="view-marks-modal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      :visible="showModal"
      @hidden="$emit('close-modal')"
    >
      <section class="d-flex">
        <section class="width-6 side-blue-bar"></section>
        <section class="width-94">
          <div class="d-flex align-items-center justify-content-between p-3">
            <div class="b-modal-header">Assessment Marks</div>
            <div class="rotate-on-hover pointer">
              <img
                @click="$emit('close-modal')"
                v-b-tooltip.hover.top="'Close'"
                src="../../../assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <hr class="my-0" />
          <section class="w-100 d-flex justify-content-between px-3">
            <section class="w-50 d-flex flex-column gap-3 test-details">
              <div class="col-gap-2">
                <span>Topic Name</span>
                <b-skeleton v-if="loader"></b-skeleton>
                <article v-else>
                  {{ marksData.topicName }}
                </article>
              </div>
              <div class="col-gap-2">
                <span>Test Name</span>
                <b-skeleton v-if="loader"></b-skeleton>
                <article v-else>
                  {{ marksData.testName }}
                </article>
              </div>
              <div class="d-flex justify-content-between">
                <div class="col-gap-2">
                  <div>
                    <img
                      src="../../../assets/img/newvendorflow/smallcalendar.svg"
                    />
                    <span class="ml-2">Start date:</span>
                  </div>
                  <b-skeleton v-if="loader"></b-skeleton>
                  <article class="fs-12" v-else>
                    {{ formatTime(marksData.config.openTestdt) }},
                    {{ formatDate(marksData.config.openTestdt) }}
                  </article>
                </div>
                <div class="col-gap-2">
                  <div>
                    <img
                      src="../../../assets/img/newvendorflow/smallcalendar.svg"
                    />
                    <span class="ml-2">End Date:</span>
                  </div>
                  <b-skeleton v-if="loader"></b-skeleton>
                  <article class="fs-12" v-else>
                    {{ formatTime(marksData.config.closeTestdt) }},
                    {{ formatDate(marksData.config.closeTestdt) }}
                  </article>
                </div>
              </div>
              <!-- <div class="d-flex gap-4">
                <div class="col-gap-2">
                  <span>Total attempts:</span>
                  <article>{{ marksData.maxnoattempts }}</article>
                </div>
                
              </div>-->
              <!-- <div class="col-gap-2 gap-0">
                <span>Test link:</span>
                <div
                  class="d-flex justify-content-between gap-3 align-items-center"
                >
                  <article class="fs-12 fw-400 color-mainblue text-underline">
                    {{ shortenLink(assessmentMarks.shareLink) }}
                  </article>
                  <div>
                    <img
                      @click="copyLink(assessmentMarks.shareLink)"
                      class="mb-2 pointer"
                      v-b-tooltip.hover="'Copy Link'"
                      src="../../assets/images/PanelistPage/copy-icon.svg"
                    />
                  </div>
                </div>
              </div>-->
            </section>
            <section class="w-50 p-3">
              <section
                class="attempt-details"
                :style="
                  currentAttempt.attemptNo &&
                  !currentAttempt.evaluation &&
                  'background: #8C8C8C0D !important;'
                "
              >
                <section
                  class="
                    attempt-header
                    font-lato
                    fs-14
                    fw-500
                    color-darkblack
                    vf-modal-header
                  "
                >
                  <div class="d-flex justify-content-between">
                    <b-skeleton v-if="loader" class="w-75 mr-2"></b-skeleton>
                    <span class="attempt-text" v-else>
                      Attempt {{ attemptNo }}
                    </span>
                    <b-skeleton v-if="loader"></b-skeleton>
                    <span
                      v-else-if="!currentAttempt.evaluation"
                      class="font-mont color-yellow fw-600 fs-12"
                    >
                      YET TO BE EVALUATED
                    </span>
                    <span
                      v-else-if="currentAttempt.resultPerAttemptStatusCode"
                      class="font-mont color-green fw-600 fs-12"
                    >
                      PASSED
                    </span>
                    <span v-else class="font-mont color-red fw-600 fs-12">
                      FAILED
                    </span>
                  </div>
                  <div
                    class="d-flex justify-content-between mt-2 attempt-sub-txt"
                  >
                    <span>Test taken on:</span>
                    <b-skeleton v-if="loader" class="w-25"></b-skeleton>
                    <span v-else class="fw-500">
                      {{ formatDate(currentAttempt.createdAt) }}
                    </span>
                    <!-- <div class="d-flex align-items-center w-50">
                      <span>Test taken on:</span>&nbsp;
                      <b-skeleton v-if="loader" class="w-25"></b-skeleton>
                      <span v-else class="fw-500">
                        {{ formatDate(currentAttempt.createdAt) }}
                      </span>
                    </div>
                    <div class="fs-12 font-lato d-flex align-items-center">
                      <span class="color-8c8c8c fw-500">Face Match Rating:</span
                      >&nbsp;<span class="color-mainblue fw-600">99%</span>
                    </div> -->
                  </div>
                </section>
                <div
                  class="
                    d-flex
                    justify-content-center
                    align-items-center
                    h-100
                    flex-column
                    p-4
                  "
                  v-if="
                    !loader &&
                    currentAttempt.attemptNo &&
                    !currentAttempt.evaluation
                  "
                >
                  <img src="@/assets/img/newkanban/not-eval-assess.svg" />
                  <span class="fs-13 font-mont" style="color: #72738e"
                    >Evaluation of this assessment is pending</span
                  >
                </div>
                <section v-else class="d-flex flex-column gap-2 p-3">
                  <div class="d-flex justify-content-between mark-text">
                    <b-skeleton v-if="loader" class="w-100"></b-skeleton>
                    <span v-else>
                      Total Marks :
                      {{ currentAttempt.totalMarksScoredPerAttempt }}/{{
                        roundToTwo(currentAttempt.totalMarksPerAttempt)
                      }}
                    </span>
                    <b-skeleton v-if="loader" class="w-100"></b-skeleton>
                    <span v-else>
                      Passing Percentage(%):
                      {{ currentAttempt.passingPercentage }}/100
                    </span>
                  </div>
                  <div>
                    <div
                      class="
                        d-flex
                        justify-content-between
                        font-lato
                        fw-500
                        fs-11
                        attempt-text
                      "
                    >
                      <span>Sections</span>
                      <span>Marks</span>
                    </div>
                    <div class="d-flex flex-column gap-2 mt-1">
                      <div v-if="loader" class="d-flex justify-content-between">
                        <b-skeleton class="w-50"></b-skeleton>
                        <b-skeleton class="w-25"></b-skeleton>
                      </div>
                      <template v-else>
                        <div
                          v-for="(
                            section, index
                          ) in currentAttempt.testResponse"
                          :key="index"
                          class="d-flex justify-content-between"
                        >
                          <span class="font-mont fs-12 fw-600">
                            {{ section.sectionName }}
                          </span>
                          <span class="fw-600 mark-text">
                            {{ roundToTwo(section.sectionMarks) }}/{{
                              roundToTwo(section.serctionTotalMarks)
                            }}
                          </span>
                        </div>
                      </template>
                    </div>
                  </div>
                </section>
              </section>
            </section>
          </section>
          <hr class="my-0" />
          <footer class="p-3 d-flex justify-content-end">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              @click="$emit('close-modal')"
              >Close</b-button
            >
          </footer>
        </section>
      </section>
    </b-modal>
  </main>
</template>
<script>
import { getAssessmentMarks } from "@/utils/apiFunctions";
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    testData: Object,
  },
  data() {
    return {
      marksData: {},
      currentAttempt: {},
      loader: false,
      attemptNo: null,
    };
  },
  created() {
    this.attemptNo = this.testData.attemptNo;
    delete this.testData.attemptNo;
    this.getAssessmentMarks();
  },
  methods: {
    copyLink(link) {
      navigator.clipboard.writeText(link);
    },
    shortenLink(link) {
      return "https://.../" + link.split("/").slice(-1);
    },
    roundToTwo(num) {
      return Math.round(num);
    },
    formatTime(date) {
      return new Date(date)
        .toLocaleString("en-IN", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
        .toUpperCase();
    },

    formatDate(date) {
      return new Date(date)
        .toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replaceAll("/", "-");
    },
    async getAssessmentMarks() {
      try {
        this.loader = true;
        const res = await getAssessmentMarks(this.testData);
        if (res.status == 200) {
          this.marksData = res.data.data;
          this.currentAttempt =
            this.marksData.assessmentResponse[this.attemptNo - 1];
        }
        this.loader = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style>
.side-blue-bar {
  width: 60px;
  border-radius: 8px 0px 0px 8px;
  background: var(--bluetheme);
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.04),
    0px 20px 24px -4px rgba(16, 24, 40, 0.1);
}
.vf-modal-header {
  border-bottom: 1px solid #e4e7ec;
  padding: 15px;
}
#view-marks-modal .modal-body {
  padding: 0rem;
}
#view-marks-modal .modal-content {
  border-radius: 12px;
}
#view-marks-modal .modal-dialog {
  max-width: 950px;
}
.col-gap-2 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.test-details span {
  font-family: "Lato", sans-serif;
  font-weight: var(--weight-LM);
  font-size: var(--size-12);
}
.test-details article {
  font-family: "montserrat", sans-serif;
  font-weight: var(--weight-M);
  font-size: var(--size-14);
}
.test-details {
  padding: 37px 25px 28px 25px;
}
.attempt-details {
  background: #f6f9fb;
  border-radius: 12px;
}
.attempt-header {
  background: #ffffff;
  border-radius: 12px 12px 0px 0px;
  border-bottom: 2px solid #20639b;
  margin: 2px;
}
.marks-footer {
  border-top: 1px solid #d7d7d7;
  padding: 16px;
}

.attempt-text {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
}

.attempt-sub-txt {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 12px;
}

.mark-text {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--bluetheme);
}
</style>
